(ns dre.components.platform-switcher.db
  (:require
   [clojure.string :as str]))

(defn- enabled?
  "Checks whether the user has required role for the given platform or not."
  [user config platform]
  (boolean
   (when-let [required-role (some-> config
                                    (get-in [platform :required-role])
                                    str/lower-case)]
     (-> user
         :roles
         set
         (contains? required-role)))))

(defn registry
  [platforms-config user]
  (remove nil? [{:id :doclabel
                 :label "Label Intelligence"
                 :url (get-in platforms-config [:doclabel :url])
                 :enabled? (enabled? user platforms-config :doclabel)}
                {:id :regintel
                 :label "Regulatory Intelligence"
                 :url (get-in platforms-config [:regintel :url])
                 :enabled? (enabled? user platforms-config :regintel)}
                {:id :docsearch
                 :label "Literature Search"
                 :url (get-in platforms-config [:docsearch :url])
                 :enabled? true}
                (when (enabled? user platforms-config :docanalytics)
                  {:id :docanalytics
                   :label "Rapid Analysis"
                   :url (get-in platforms-config [:docanalytics :url])
                   :enabled? true})
                {:id :trialsintel
                 :label "Trials Intelligence"
                 :url (get-in platforms-config [:trialsintel :url])
                 :enabled? (enabled? user platforms-config :regintel)}]))


(defn index
  [platforms-config user]
  (into {} (map (juxt :id identity)) (registry platforms-config user)))
